var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Tooltip } from '@hn-ui/tooltips';
import { BlueExternalLink, BlueLink } from '@hn-ui/links';
import { Help } from '@hn-ui/icons';
import { cs } from '@hn-front/data-types';
import { LabelsByAssessment } from '../../constants/texts';
import { useAssessmentsReportContext } from '../../hooks/useAssessmentsReportContext';
import { HelpLink } from '../../constants/links';
var HelpCenterTooltip = function (_a) {
    var children = _a.children, props = __rest(_a, ["children"]);
    var context = useAssessmentsReportContext()[0];
    return (_jsx(Tooltip, __assign({}, props, { maxWidth: 302, content: _jsxs("div", { children: ["Visit our", ' ', _jsx(BlueExternalLink, __assign({ href: HelpLink[context] }, { children: "Help Center article" }), void 0), ' ', "to check how you can identify students who have not completed the test"] }, void 0) }, { children: children }), void 0));
};
var getSetupAssessmentContent = function (_a) {
    var test = _a.test, setup = _a.setup;
    if (test === 'primary') {
        return (_jsxs("div", { children: ["The placement test is mandatory for K-5 students and starts automatically. To learn more,", ' ', _jsx(BlueExternalLink, __assign({ href: HelpLink.primaryAssessment }, { children: "visit our Help Center" }), void 0)] }, void 0));
    }
    return (_jsxs("div", { children: ["To ", setup ? 'setup' : 'change', " ", LabelsByAssessment[test], " Test start date please contact us at", ' ', _jsx(BlueLink, __assign({ href: "mailto:" + cs.email }, { children: cs.email }), void 0)] }, void 0));
};
var SetupAssessmentTooltip = function (_a) {
    var test = _a.test, setup = _a.setup, children = _a.children, props = __rest(_a, ["test", "setup", "children"]);
    return (_jsx(Tooltip, __assign({}, props, { maxWidth: 310, content: getSetupAssessmentContent({ test: test, setup: setup }) }, { children: children }), void 0));
};
var SetupAssessmentHelp = function (_a) {
    var props = __rest(_a, []);
    return (_jsx(SetupAssessmentTooltip, __assign({}, props, { children: _jsx(Help, { color: 'black70', size: 20 }, void 0) }), void 0));
};
export { HelpCenterTooltip, SetupAssessmentHelp };
